





















































































































































































































































































































































import { fetchMID } from './fetchMID';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { ComponenteBaseStepper } from '../../views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { EstadoInterface } from '@/interfaces/Estado';
import { LoadingService } from '@/services/loadingService';
import { EstadoEntidad } from '@/config/enums';
import { EstadosService } from '@/services/estadosService';
import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';
const { AgGridVue } = require('ag-grid-vue');
import Confirmation from '@/components/Confirmation.vue'; //
import store from '@/store';

@Component({
  components: {
    DatePicker,
    'ag-grid-vue': AgGridVue,
    'app-confirmacion': Confirmation,
  },
})
export default class FormCrearWs extends ComponenteBaseStepper {
  [x: string]: any;
  @Prop({ default: false }) show: boolean;
  @Prop({ required: true }) usuarioActivo: any;
  @Prop({ required: true }) clientesAll!: any;
  $snotify: any;
  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Maximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
  };
  selected: any[] = [];
  selectedFlotas: any[] = [];
  endPoints: any = [];
  selectedItem: any = 'Flotas';
  codeVehiculo: string = '';
  patente: string = '';
  id: any = 40;
  groupBy: any = [{ key: 'flotaId', order: 'desc' }];
  formFields: {
    endPoint: any;
    clientes: any;
  } = {
    endPoint: {
      label: 'EndPoint',
      value: '',
      items: this.endPoints,
    },
    clientes: {
      label: 'Clientes',
      value: '',
      items: this.clientesAll,
      formatItem: (item: { nombre: any; rut: any }) =>
        `${item.nombre} [${item.rut}]`,
    },
  };
  headersFlotas: any = [
    { text: 'Flota', value: 'flota', width: '500' },
    { text: 'Plataforma', value: 'plataforma' },
    { text: 'Todos', value: '__id_cliente' },
  ];
  headersVehiculos: any = [
    { text: 'Grupo', value: 'Grupo', width: '300', sortable: true },
    { text: 'Patente', value: 'patente', sortable: true },
    { text: 'Plataforma', value: 'Nombre Vehiculo', sortable: true },
    { text: 'Última Actividad', value: 'Última Actividad', sortable: true },
    { text: 'Todos', value: '__id_cliente', sortable: true },
  ];
  itemsFlotas: any = [];
  itemsVehiculos: any = [];
  pagination: any = {
    rowsPerPage: 5,
  };
  rowsPerPage: any = [5, 10, 25, { text: 'Todos', value: -1 }];
  guardarInactivo = false;

  selectedendPoint() {
    return this.formFields.endPoint.items.find(
      (item: { id: any }) => item.id === this.formFields.endPoint.value
    );
  }

  selectedRadio(e: any) {
    switch (e) {
      case 'Flotas':
        this.selectedItem = 'Flotas';
        break;
      case 'Vehiculos':
        this.selectedItem = 'Vehiculos';
        break;
    }
  }

  isSelectedVehiculo(id: number) {
    return this.selected.includes(id);
  }

  toggleSelectionVehiculo(id: number) {
    const index = this.selected.indexOf(id);
    if (index === -1) {
      // Agregar el id si no está en el array
      this.selected.push(id);
    } else {
      // Eliminar el id si ya está en el array
      this.selected.splice(index, 1);
    }
  }

  isSelectedFlota(id: number) {
    return this.selectedFlotas.includes(id);
  }

  toggleSelectionFlota(id: number) {
    const index = this.selectedFlotas.indexOf(id);
    if (index === -1) {
      // Agregar el id si no está en el array
      this.selectedFlotas.push(id);
      // Realizar la búsqueda de vehículos con la flota seleccionada
      const vehiculosConFlotaSeleccionada = this.itemsVehiculos.filter(
        (vehiculo: { flotaId: number }) => vehiculo.flotaId === id
      );
      // Almacenar los ids de los vehículos encontrados
      const idsVehiculosConFlotaSeleccionada = vehiculosConFlotaSeleccionada.map(
        (vehiculo: { id: any }) => vehiculo.id
      );
      // Guardar los ids de los vehículos en algún lugar (por ejemplo, en una variable)
      this.idsVehiculosConFlotaSeleccionada = idsVehiculosConFlotaSeleccionada;
    } else {
      // Eliminar el id si ya está en el array
      this.selectedFlotas = this.selectedFlotas.filter(
        (item: number) => item !== id
      );
      const vehiculosConFlotaDeseleccionada = this.itemsVehiculos.filter(
        (vehiculo: { flotaId: number }) => vehiculo.flotaId === id
      );
      // Almacenar los ids de los vehículos encontrados
      const idsVehiculosConFlotaDeseleccionada = vehiculosConFlotaDeseleccionada.map(
        (vehiculo: { id: any }) => vehiculo.id
      );
      this.idsVehiculosConFlotaSeleccionada = this.idsVehiculosConFlotaSeleccionada.filter(
        (item: any) => !idsVehiculosConFlotaDeseleccionada.includes(item)
      );
    }
  }

  async getEndpoint() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(
      { clienteid: this.formFields.clientes.value.toString() },
      'mid_cliente/GetTotalVehiculosIntegrador'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        console.error('Error:', error);
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async getFlotas() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(
      { clienteid: this.formFields.clientes.value.toString() },
      'mid_cliente/GetFlotasPorCliente'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.itemsFlotas = data.data.data.filter(
            (item: { flotaid: string; flota: string }) =>
              item.flota.trim() !== ''
          );
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async getVehiculos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(
      { clienteid: this.formFields.clientes.value.toString() },
      'mid_cliente/getVehicles'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.itemsVehiculos = data.data.data;
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async crearProvee() {
    let self = this;
    return fetchMID(
      {
        clienteid: this.formFields.clientes.value,
        vehiculos: this.selected && this.idsVehiculosConFlotaSeleccionada,
        flotas: this.selectedFlotas,
        id: this.formFields.endPoint.value.toString(),
        userid: store.state.userId,
      },
      'mid_cliente/PostInserteRelacionVehiculo'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success('Creación exitosa', { timeout: 3000 });
          this.closeModal(false);
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Error al crear el endpoint', { timeout: 3000 });
      });
  }

  nuevoDato: any = {};

  crear() {
    if (this.formFields.endPoint.value != '') {
      if (
        this.selected.length > 0 ||
        this.idsVehiculosConFlotaSeleccionada > 0
      ) {
        this.crearProvee();
      } else {
        this.$snotify.error('Por favor seleccion una flota o vehículo', {
          timeout: 3000,
        });
      }
    } else {
      this.$snotify.error('Por favor seleccion un endpoint valido', {
        timeout: 3000,
      });
    }
  }

  mounted() {}

  // permisos
  permisosActuales: PermisoAccionVm[] = [];

  // Declarar todas las posibles subAcciones
  asociarCliente: PermisoAccionVm = {
    accion: 'Crear - Información General',
    visible: true,
    step: 1,
    codigoAccionPadre: CodigoAccion.Crear,
    codigoSubAccion: 19,
  };

  asociarEnpoint: PermisoAccionVm = {
    accion: 'Crear - Información General',
    visible: true,
    step: 2,
    codigoAccionPadre: CodigoAccion.Crear,
    codigoSubAccion: 19,
  };

  asociarVehiculos: PermisoAccionVm = {
    accion: 'Crear - Asociar Vehículos',
    visible: true,
    step: 3,
    codigoAccionPadre: CodigoAccion.Crear,
    codigoSubAccion: 19,
  };

  permisosTotales: PermisoAccionVm[] = [
    this.asociarEnpoint,
    this.asociarVehiculos,
  ];

  // Globales
  e1: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = true;
  validForm: boolean = false;
  loadingService = new LoadingService();
  btnBloquear: boolean = false;
  warningInactivo: any = '';
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;

  //data
  estadosServices: EstadosService = new EstadosService();
  estados: EstadoInterface[] = this.estadosServices.getEstadosVisibles();

  //Interface
  editedItem: IFuncionalidad = {};

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  closeModal(val: boolean) {
    document.getElementById('cardDivP').scrollIntoView(true);
    this.editedItem = {};
    this.e1 = 1;
    this.$emit('datoCreado', true);
    this.$emit('modalAsociacionEmit', false);
    this.$validator.reset(); //Reset Validaciones
    this.dialog = false;

    this.btnText = 'Continuar';
    this.btnClass = 'btn-continuar';

    this.show = false;
    this.guardarInactivo = false;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }
  async continuar() {
    if (this.formFields.clientes.value != '') {
      if (this.e1 == 2) {
        this.getFlotas();
        this.getVehiculos();
      }
      this.getEndpoint();
      this.ordesList = (await this.getEndpoint()) || [];
      this.endPoints = this.ordesList
        .filter(
          (item: { total_vehiculos: number }) => item.total_vehiculos === 0
        )
        .map(
          (item: {
            integracion: { id: any; nombrewebservice: any };
            total_vehiculos: any;
          }) => ({
            id: item.integracion.id,
            nombre_ws: item.integracion.nombrewebservice,
            total_vehiculos: item.total_vehiculos,
          })
        )
        .sort((a: any, b: any) => {
          if (a.nombre_ws > b.nombre_ws) {
            return 1;
          } else if (a.nombre_ws < b.nombre_ws) {
            return -1;
          } else {
            return 0;
          }
        });
      this.$validator.validateAll().then(resultado => {
        if (resultado) {
          document.getElementById('cardDivP').scrollIntoView(true);
          if (this.e1 == 3) {
            this.btnText = 'Guardar';
            this.btnClass = 'btn-grabar';
          } else {
            this.e1++;
          }
        }
      });
    } else {
      this.$snotify.error('Por favor selecciona un cliente', {
        timeout: 3000,
      });
    }
  }

  volver() {
    this.e1 -= 1;
    this.btnText = 'Continuar';
    this.btnClass = 'btn-continuar';
    document.getElementById('cardDivP').scrollIntoView(true);
  }

  cierraMenuPerfil() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }
}
